import { countLoads } from './quoteRequestUtils'
import { useQuoteFormState } from './useQuoteFormState'

export const useCanUseMultiTruck = () =>
  useQuoteFormState(s => !s.isCustomerRouted && !s.selectedTemplate)

export const useCanUseTemplates = () =>
  useQuoteFormState(s => countLoads(s.loads) <= 1)
